import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  spinner: {
    marginBottom: theme.spacing(2),
    color: '#40B9C3',
  },
  text: {
    color: '#666',
    fontSize: '1rem',
    fontWeight: 500,
  },
}));

const LoadingOverlay = ({ 
  open = false, 
  message = 'Loading...', 
  size = 40,
  transparent = false 
}) => {
  const classes = useStyles();

  if (!open) return null;

  return (
    <Backdrop 
      className={classes.backdrop} 
      open={open}
      style={{ 
        backgroundColor: transparent ? 'transparent' : 'rgba(255, 255, 255, 0.8)' 
      }}
    >
      <div className={classes.container}>
        <CircularProgress 
          size={size} 
          className={classes.spinner}
        />
        <div className={classes.text}>{message}</div>
      </div>
    </Backdrop>
  );
};

export default LoadingOverlay;
